module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "offcie-warp"
  }, [_c('div', {
    staticClass: "title-warp"
  }, [_c('div', {
    staticClass: "pic-warp"
  }, [_c('div', {
    staticClass: "pic",
    staticStyle: {
      "background-image": "url('static/images/ex_pic13.jpg')"
    }
  }), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.zoneDetail.name))]), _vm._v(" "), _c('h4', [_vm._v("执业证号：" + _vm._s(_vm.zoneDetail.code))]), _vm._v(" "), _c('h4', [_vm._v("通讯地址：" + _vm._s(_vm.zoneDetail.address))])]), _vm._v(" "), _c('div', {
    staticClass: "number-warp"
  }, [_c('div', {
    staticClass: "inner-warp"
  }, [_c('div', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.zoneDetail.todaynumber))]), _vm._v(" "), _c('p', [_vm._v("今日业务量")])]), _vm._v(" "), _c('div', {
    staticClass: "inner-warp"
  }, [_c('div', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.zoneDetail.allnumber))]), _vm._v(" "), _c('p', [_vm._v("业务总量")])]), _vm._v(" "), _c('div', {
    staticClass: "inner-warp"
  }, [_c('div', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.zoneDetail.personnel))]), _vm._v(" "), _c('p', [_vm._v("公证员")])]), _vm._v(" "), _c('div', {
    staticClass: "inner-warp"
  }, [_c('div', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.zoneDetail.company))]), _vm._v(" "), _c('p', [_vm._v("办证室")])])])]), _vm._v(" "), _c('div', {
    staticClass: "personnel-list-warp"
  }, [_c('h3', [_vm._v("今日在岗公证人（" + _vm._s(_vm.zoneDetail.personnelList.length) + "）人")]), _vm._v(" "), _c('div', {
    staticClass: "pf-iner-box"
  }, [_c('personnel-list', {
    attrs: {
      "listArr": _vm.zoneDetail.personnelList
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "office-list-warp"
  }, [_c('div', {
    staticClass: "pf-iner-box"
  }, [_c('h3', [_vm._v("办证室（" + _vm._s(_vm.zoneDetail.companyList.length) + "）间")]), _vm._v(" "), _c('office-list', {
    attrs: {
      "listArr": _vm.zoneDetail.companyList
    }
  })], 1)]), _vm._v(" "), _c('a', {
    staticClass: "go-back",
    attrs: {
      "href": "#/index/aside"
    },
    on: {
      "click": function($event) {
        _vm.goback(true)
      }
    }
  }, [_vm._v("×")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-61463c20"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/office.vue
// module id = 182
// module chunks = 1